export const state = {
    filaToRemove: {},
    filaToEdit: {},
    updateSubFilas: 0,
    filasGuiche: [],
}

export const mutations = {
    SET_FILA_TO_REMOVE(state, payload) {
        state.filaToRemove = payload
    },
    SET_FILA_TO_EDIT(state, payload) {
        state.filaToEdit = payload
    },
    SET_UPDATE_SUB_FILAS(state) {
        state.updateSubFilas++
    },
    SET_FILAS_GUICHE(state, payload) {
        state.filasGuiche.push(payload)
    },
    REMOVE_FILAS_GUICHE(state, payload) {
        let index = state.filasGuiche.findIndex(f => f.idFila === payload.idFila)
        if (index >= 0) {
            state.filasGuiche.splice(index, 1)
        }
    },
    CLEAN_FILAS_GUICHE(state) {
        state.filasGuiche = []
    },
}

export const actions = {
    changeFilaToRemove({ commit }, payload) {
        commit('SET_FILA_TO_REMOVE', payload)
    },
    changeFilaToEdit({ commit }, payload) {
        commit('SET_FILA_TO_EDIT', payload)
    },
    changeUpdateSubFilas({ commit }) {
        commit('SET_UPDATE_SUB_FILAS')
    },
    pushFilasGuiche({ commit }, payload) {
        commit('SET_FILAS_GUICHE', payload)
    },
    removeFilasGuiche({ commit }, payload) {
        commit('REMOVE_FILAS_GUICHE', payload)
    },
    cleanTotemStore({dispatch, commit}) {
        dispatch('changeFilaToRemove', {})
        dispatch('changeFilaToEdit', {})
        commit('CLEAN_FILAS_GUICHE')
    },
}
